type IconProps = { size?: number; className?: string };

export function MentionUsersIcon({ size = 18, className }: IconProps) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 18 18" fill="none" aria-hidden>
      <circle cx="9" cy="6" r="3" stroke="currentColor" strokeWidth="1.4" />
      <path
        d="M3.5 15.5c0-2.8 2.5-4.5 5.5-4.5s5.5 1.7 5.5 4.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function MentionMonitorIcon({ size = 18, className }: IconProps) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 18 18" fill="none" aria-hidden>
      <rect x="2" y="3" width="14" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
      <path d="M7 15.5h4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

export function MentionCredentialIcon({ size = 18, className }: IconProps) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 18 18" fill="none" aria-hidden>
      <rect x="2.5" y="4" width="13" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
      <path d="M5.5 9h2M10.5 9h2M5.5 11.5h1.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  );
}

export function MentionCalendarIcon({ size = 18, className }: IconProps) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 18 18" fill="none" aria-hidden>
      <rect x="2.5" y="4" width="13" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
      <path d="M6 3v2.5M12 3v2.5M2.5 8h13" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

export function MentionPersonRowIcon({ size = 20, className }: IconProps) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 20 20" fill="none" aria-hidden>
      <circle cx="10" cy="7" r="3.25" stroke="currentColor" strokeWidth="1.35" />
      <path
        d="M4 17c0-3.2 2.7-5.25 6-5.25s6 2.05 6 5.25"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
      />
    </svg>
  );
}

export type MentionCategoryId =
  | 'users'
  | 'access-groups'
  | 'credentials'
  | 'devices'
  | 'schedules';

export function MentionCategoryIcon({
  categoryId,
  size = 18,
  className,
}: {
  categoryId: MentionCategoryId;
  size?: number;
  className?: string;
}) {
  switch (categoryId) {
    case 'users':
      return <MentionUsersIcon size={size} className={className} />;
    case 'access-groups':
    case 'devices':
      return <MentionMonitorIcon size={size} className={className} />;
    case 'credentials':
      return <MentionCredentialIcon size={size} className={className} />;
    case 'schedules':
      return <MentionCalendarIcon size={size} className={className} />;
    default:
      return null;
  }
}
